import React from 'react';
import PropTypes from 'prop-types';
import { CloudArrowUp } from '@phosphor-icons/react';
import ImageUpload from './imageUpload';
import './style';

const EventImage = (props) => {
  const { 
    showHeader,
    setFormData, 
    formData, 
    enableDelete,
    isEventImageUploading,
    eventImagesRef,
    readOnly,
  } = props;
 
  return (
    <>
      {showHeader && (
        <div className="mb-8 flex flex-col gap-4">
          <h1 className="heading-36">Main event image</h1>
          <p>
            Add an image to show what your event will be about.{' '}
          </p>
        </div>
      )}

  <div className="flex flex-col justify-start items-center gap-3 pr-4 flex-1 md:justify-center">
        {isEventImageUploading ? (
          <div className="flex flex-col gap-5 justify-center items-center flex-1 p-32">
            <CloudArrowUp
              size={20}
              color="#101010"
            />
            <p className="text-16 text-black text-center">
              Image is being uploaded. You can always edit it later in your event dashboard. 
            </p>
          </div>
        ) : (
          <ImageUpload
            formData={formData}
            setFormData={setFormData}
            enableDelete={enableDelete}
            eventImagesRef={eventImagesRef}
            readOnly={readOnly}
          />
        )}
        {(!formData?.full_image && !eventImagesRef?.current?.full_image) && <p>Recommended: 1280 * 720px</p>}
      </div>
    </>
  );
};

EventImage.propTypes = {
  setFormData: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  showHeader: PropTypes.bool,
  enableDelete: PropTypes.bool,
  isEventImageUploading: PropTypes.bool,
  eventImagesRef: PropTypes.object,
};

EventImage.defaultProps = {
  setFormData: () => {},
  formData: {},
  showHeader: true,
  enableDelete: true,
  isEventImageUploading: false,
  eventImagesRef: null,
};

export default EventImage;
